<template>
  <div id="dashboard">
    <ks-header :shadow="false">
      <template #left>
        <div />
      </template>
      <template #center>
        <b-nav-item router-link :to="`/${$route.params.locale}/`">
          <img
            height="54px"
            class="logo p-0"
            src="@/assets/images/logos/kf_logo.png"
            :alt="$t('navbar.logo')"
            role="img"
          >
        </b-nav-item>
      </template>
      <template #right>
        <locale-changer />
      </template>
    </ks-header>

    <div id="main-container" v-scroll-lock="true">
      <div id="main-content">
        <ks-carousel :institutions="institutions" />

        <b-container class="ks-card-container pt-3 pb-2">
          <b-row class="justify-content-center">
            <ks-card
              :route="`/${$route.params.locale}/institutions/map?isFavorite=false`"
              :text="$t('common.map')"
              :image-source="require(`@/assets/images/icons/cards/map.svg`)"
            />
            <ks-card
              :route="`/${$route.params.locale}/institutions/list?isFavorite=false`"
              :text="$t('common.list')"
              :image-source="require(`@/assets/images/icons/cards/list.svg`)"
            />
          </b-row>
          <b-row class="justify-content-center">
            <ks-card
              :route="`/${$route.params.locale}/institutions/list?isFavorite=true`"
              :text="$t('common.favorites')"
              :image-source="require(`@/assets/images/icons/cards/favorites.svg`)"
              :small="true"
            />
            <ks-card
              :route="`/${$route.params.locale}/institutions/map/filters`"
              :text="$t('common.filters')"
              icon="controls"
              :small="true"
            />
          </b-row>
          <b-row class="justify-content-center">
            <ks-card
              :route="`/${$route.params.locale}/institutions/list?tags=Living%20Image`"
              :text="$t('dashboard.living-images')"
              icon="living-images"
              :small="true"
            />
            <ks-card
              :route="`/${$route.params.locale}/institutions/map?tags=Schietwetter`"
              :text="$t('dashboard.schietwetter')"
              :image-source="require(`@/assets/images/icons/cards/indoor.svg`)"
              :small="true"
            />
          </b-row>
        </b-container>

        <b-row wrap class="w-100 m-0 pt-2 pb-2 justify-content-center">
          <b-btn
            variant="link"
            v-b-modal.pwa-modal
            class="footer-text px-2 pt-0 pb-3 text-decoration-none"
            v-if="showDownloadLink"
          >
            <icon-base
              width="18"
              height="18"
              color="#576165"
            >
              <icon-download />
            </icon-base>
            {{ $t("common.downloadApp") }}
          </b-btn>
          <b-btn
            variant="link"
            v-b-modal.sign-language-modal
            class="footer-text px-2 pt-0 pb-3 text-decoration-none"
          >
            <icon-base
              width="18"
              height="18"
              color="#576165"
            >
              <icon-sign-language />
            </icon-base>
            {{ $t("dashboard.signLanguage") }}
          </b-btn>
          <sign-language-modal />
          <router-link
            :to="`/${$route.params.locale}/about`"
            class="footer-text px-2 pt-0 pb-3"
          >
            <icon-base
              width="18"
              height="18"
              color="#576165"
            >
              <icon-privacy />
            </icon-base>
            {{ $t("navbar.legalNotice") }}
          </router-link>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import KsCarousel from '@/components/dashboard/Carousel.vue'
import KsCard from '@/components/dashboard/Card.vue'
import KsHeader from '@/components/layout/Header'
import { mapGetters } from 'vuex'
import LocaleChanger from '../components/dashboard/LocaleChanger'
import SignLanguageModal from '../components/dashboard/SignLanguageModal.vue'
import ScrollPosition from '@/mixins/scrollposition'
import detectRTC from 'detectrtc'

export default {
  name: 'Dashboard',
  data() {
    return {
      downloadSupportedOS: [
        'Windows',
        'Mac',
        'Android',
        'iOS'
      ]
    }
  },
  components: {
    LocaleChanger,
    KsCarousel,
    KsCard,
    KsHeader,
    SignLanguageModal
  },
  mixins: [ScrollPosition],
  computed: {
    ...mapGetters({
      institutions: 'institutions/getAll'
    }),
    showDownloadLink() {
      return this.downloadSupportedOS.includes(detectRTC.osName) &&
        !window.matchMedia('(display-mode: standalone)').matches
    }
  }
}
</script>

<style lang="scss" scoped>
#main-content {
  background-color: $gray;
}
.ks-card-container {
  background-color: $gray
}
.b-dropdown {
  background-color: var(--white) !important;
  > .dropdown-menu {
    min-width: 0;
    padding: 0;
    margin: 0;
    transform: translate3d(-20px, 40px, 0px);
  }
}
#dropdown-1__BV_toggle_{
  display: flex !important;
  // flex-direction: row !important;
  align-items: center !important;
}
.footer-text{
  font-size: 0.7rem;
  color: #576165;
}
.logo {
  width: auto;
  height: 40px;
}
.flag {
  width: auto;
  height: 30px;
}
</style>
